<template>
  <div>
    <div
      class="form-group variable-selector">
      <label-select
        v-model="category"
        v-on:input="$emit('input', category)"
        form-size="m"
        :label="label"
        :error-message="errorMessage"
        :options="selectCategories"
        :disabled="disabled"
        :searchable="!disabled"
        :error="error">
      </label-select>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import LabelSelect from '@/components/shared/forms/LabelSelect';

export default {
  name: 'CategorySelector',
  components: {
    LabelSelect,
    vSelect
  },
  props: {
    value: {
      type: Object,
      default: () => {}
    },
    categories: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String
    },
    placeholder: {
      type: String
    },
    type: {
      type: String,
      default: 'text'
    },
    error: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: 'Error'
    }
  },
  watch: {
    value: {
      handler: function (value) {
        this.category = value;
      }
    }
  },
  data () {
    return {
      category: this.value
    };
  },
  computed: {
    selectCategories () {
      const selectCategories = this.categories.slice();
      selectCategories.forEach(category => {
        category.label = category.name;
        category.value = category.id;
      });
      return selectCategories;
    }
  },
  methods: {
    onOk () {
      this.showModal = false;
    },
    onCancel () {
      this.showModal = false;
    }
  }
};
</script>

<style lang="scss" scoped>
  @import "../../stylesheets/variables.scss";
</style>



// WEBPACK FOOTER //
// src/components/variable/CategorySelector.vue